import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 mt-5" }
const _hoisted_4 = { class: "table_style" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center gap-3 mt-3 mb-4"
}
const _hoisted_6 = { class: "d-flex align-items-center gap-2" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "pagination-mini" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled", "onClick"]
const _hoisted_11 = ["disabled"]

import { ref, reactive, computed, onMounted, defineAsyncComponent } from "vue";
import apiService from "@/services/apiService";
import CommonTable2 from "@/components/commen/table/CommonTable2.vue";
import TableTitle from "@/components/commen/table/TableTitle.vue";
import { toast } from "vue3-toastify";
import { usePermissions } from "@/composables/usePermissions";


export default /*@__PURE__*/_defineComponent({
  __name: 'BlogCategoriesList',
  setup(__props) {

const { canView, canCreate, canUpdate, canDelete } = usePermissions();

const BlogCategoryModal = defineAsyncComponent(
  () => import("@/components/theme/admin/blogs/BlogCategoryModal.vue")
);

const BlogCategoryViewModal = defineAsyncComponent(
  () => import("@/components/theme/admin/blogs/BlogCategoryViewModal.vue")
);

// State
const categories = ref([]);
const loading = ref(false);
const filters = reactive({
  status: "",
  featured: Boolean,
});

// Pagination
const tablePagination = reactive({
  current_page: 1,
  per_page: 10,
  total: 0,
  total_pages: 0,
  has_prev: false,
  has_next: false,
});

// Dynamic Pages
const visiblePages = computed(() => {
  const total = tablePagination.total_pages;
  const current = tablePagination.current_page;

  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  let pages = [1];

  if (current > 4) pages.push("...");
  for (
    let i = Math.max(2, current - 1);
    i <= Math.min(total - 1, current + 1);
    i++
  ) {
    pages.push(i);
  }
  if (current < total - 3) pages.push("...");
  pages.push(total);

  return pages;
});

// Fetch Data
const fetchCategories = async () => {
  loading.value = true;
  const res = await apiService.getBlogCategories({
    page: tablePagination.current_page,
    limit: tablePagination.per_page,
    status: filters.status,
    featured: filters.featured,
  });

  // categories.value = res.data;
  categories.value = res.data.map((item: any) => ({
    _id: item._id,
    icon: item.icon,
    title: item.title,
    slug: item.slug,
    article_count: item.blog_count,
    created_at: item.created_at
      ? new Date(item.created_at).toLocaleDateString()
      : "",
    sort_order: item.sort_order,
    is_featured: item.is_featured,
    is_active: item.is_active
  }));
  console.log(categories.value, "all categories");
  tablePagination.total = res.pagination.total;
  tablePagination.total_pages = Math.ceil(res.total / tablePagination.per_page);
  tablePagination.has_prev = tablePagination.current_page > 1;
  tablePagination.has_next =
    tablePagination.current_page < tablePagination.total_pages;

  loading.value = false;
};

// Table Config
const tableConfig = ref({
  loading: loading,
  data: categories,
  columns: [
    { name: "Icon", field: "icon", width: "auto" },
    { name: "Title", field: "title", sortable: true, width: "auto" },
    { name: "Slug", field: "slug", type: "code", width: "auto" },
    { name: "Articles", field: "article_count", type: "badge", width: "auto" },
    {
      name: "Featured",
      field: "featured",
      type: "toggle_feature",
      width: "auto",
    },
    {
      name: "Status",
      field: "is_active",
      type: "toggle_status",
      width: "auto",
    },
    { name: "Sort Order", field: "sort_order", type: "badge", width: "auto" },
    { name: "Created", field: "created_at", type: "date", width: "auto" },
  ],
  actions: [true],
  showStatusFilter: true,
  allStatusLables: ["Active", "Inactive"],
  categories: ["Featured", "Regular"],
  showFeaturedFilter: true,
  showResetFilter: true,
});

// Pagination handlers
const handlePageChange = (page: number) => {
  tablePagination.current_page = page;
  fetchCategories();
};

const changeRows = () => {
  tablePagination.current_page = 1;
  fetchCategories();
};

// Filters
const handleStatusFilter = (value: string) => {
  console.log(value, "this is status") 
     filters.status = value.toLowerCase();
     fetchCategories();
};

const handleFeaturedFilter = (value: string) => {
  const val = value.toLowerCase();

  filters.featured =
    val === "featured" ? true :
    val === "regular" ? false :
    "";
  fetchCategories();
};

const resetFilters = () => {
  filters.status = "";
  filters.featured = "";
  tablePagination.current_page = 1;
  fetchCategories();
};


// CRUD Actions
const editCategory = (cat) => {
  selectedCategory.value = cat;
  isEditMode.value = true;
  showModal.value = true;
};

const viewCategory = (cat) => {
  selectedCategory.value = cat;
  showViewModal.value = true;
};

const deleteCategory = async (id) => {
    if (
    !confirm(
      "Are you sure you want to delete this category? This action cannot be undone."
    )
  ) {
    return;
  }
   try {
    await apiService.deleteBlogCategory(id);
    await fetchCategories();
    toast.success("Category deleted successfully");
  } catch (error) {
    console.error("Error deleting category:", error);
    toast.error("Failed to delete category");
  }
};

const toggleStatus = async (id: string, status: boolean) => {
  try {
    // Optimistic update - update UI immediately
    const categoryIndex = categories.value.findIndex((cat) => cat._id === id);
    console.log(categoryIndex, "finded category");
    if (categoryIndex !== -1) {
      categories.value[categoryIndex].is_active = status;
    }

    await apiService.toggleBlogCategoryStatus(id, status);
    toast.success(
      `Category ${status ? "activated" : "deactivated"} successfully`
    );

    // Refresh data to ensure consistency
    await fetchCategories();
  } catch (error) {
    console.error("Error toggling status:", error);
    toast.error("Failed to update category status");

    // Revert optimistic update on error
    const categoryIndex = categories.value.findIndex((cat) => cat._id === id);
    if (categoryIndex !== -1) {
      categories.value[categoryIndex].is_active = !status;
    }
  }
};

const toggleFeatured = async (id: string) => {
  try {
    // Optimistic update - update UI immediately
    const categoryIndex = categories.value.findIndex((cat) => cat._id === id);
    if (categoryIndex !== -1) {
      categories.value[categoryIndex].is_featured = !categories.value[categoryIndex].is_featured;
    }

    await apiService.toggleBlogCategoryFeatured(id, categories.value[categoryIndex].is_featured);
    toast.success(
      `Category ${categories.value[categoryIndex].is_featured ? "marked as featured" : "removed from featured"}`
    );

    // Refresh data to ensure consistency
    await fetchCategories();
  } catch (error) {
    console.error("Error toggling featured:", error);
    toast.error("Failed to update featured status");

    // Revert optimistic update on error
    const categoryIndex = categories.value.findIndex((cat) => cat._id === id);
    if (categoryIndex !== -1) {
      categories.value[categoryIndex].is_featured = !featured;
    }
  }
};

// Modals
const showModal = ref(false);
const showViewModal = ref(false);
const selectedCategory = ref(null);
const isEditMode = ref(false);

const openCreateModal = () => {
  selectedCategory.value = null;
  isEditMode.value = false;
  showModal.value = true;
};

const closeModal = () => (showModal.value = false);
const closeViewModal = () => (showViewModal.value = false);

const handleCategorySaved = () => {
  fetchCategories();
  closeModal();
  toast.success("Saved successfully");
};

onMounted(fetchCategories);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(TableTitle, {
          title: "Blog Categories",
          pageTitle: "Blog Categories",
          icon: "fas fa-book",
          showAction: true,
          actionLabel: "Create Category",
          onAction: openCreateModal,
          disabled: !_unref(canCreate)('website')
        }, null, 8, ["disabled"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(CommonTable2, {
            tableObj: tableConfig.value,
            onEdit: editCategory,
            onDelete: deleteCategory,
            onView: viewCategory,
            onToggleFeatured: toggleFeatured,
            onStatusFilter: handleStatusFilter,
            onFeaturedFilter: handleFeaturedFilter,
            onToggleStatus: toggleStatus,
            onResetFilters: resetFilters,
            permissionKey: "website"
          }, null, 8, ["tableObj"])
        ]),
        (tablePagination.total_pages >= 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-muted" }, "Rows per page:", -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm rows-select",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tablePagination.per_page) = $event)),
                  onChange: changeRows
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([5, 10, 20, 50, 100], (n) => {
                    return _createElementVNode("option", {
                      key: n,
                      value: n
                    }, _toDisplayString(n), 9, _hoisted_7)
                  }), 64))
                ], 544), [
                  [_vModelSelect, tablePagination.per_page]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "page-btn prev_btn",
                  disabled: !tablePagination.has_prev,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handlePageChange(tablePagination.current_page - 1)))
                }, " « ", 8, _hoisted_9),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (p, index) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: index,
                    class: _normalizeClass(["page-btn", {
                'page-active': p === tablePagination.current_page,
                'disabled-dots': p === '...',
              }]),
                    disabled: p === '...',
                    onClick: ($event: any) => (p !== '...' && handlePageChange(p))
                  }, _toDisplayString(p), 11, _hoisted_10))
                }), 128)),
                _createElementVNode("button", {
                  class: "page-btn next_btn",
                  disabled: !tablePagination.has_next,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (handlePageChange(tablePagination.current_page + 1)))
                }, " » ", 8, _hoisted_11)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (showModal.value)
      ? (_openBlock(), _createBlock(_unref(BlogCategoryModal), {
          key: 0,
          show: showModal.value,
          category: selectedCategory.value,
          "is-edit": isEditMode.value,
          onClose: closeModal,
          onSaved: handleCategorySaved
        }, null, 8, ["show", "category", "is-edit"]))
      : _createCommentVNode("", true),
    (showViewModal.value)
      ? (_openBlock(), _createBlock(_unref(BlogCategoryViewModal), {
          key: 1,
          show: showViewModal.value,
          category: selectedCategory.value,
          onClose: closeViewModal
        }, null, 8, ["show", "category"]))
      : _createCommentVNode("", true)
  ]))
}
}

})